import { logoStyles } from "@insite/content-library/Widgets/Basic/Logo";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { css } from "styled-components";

logoStyles.wrapper = {
    css: css`
        max-width: none;
        max-height: 110px;
        span {
            display: flex;
        }
        justify-content: center;
        display: flex;
        img {
            height: auto;
            max-width: 320px;
        }
        ${({ theme }) => {
            return breakpointMediaQueries(theme, [
                css`
                    justify-content: center;
                    img {
                        height: auto;
                        width: 100%;
                    }
                `,
                css`
                    justify-content: center;
                    img {
                        height: auto;
                    }
                `,
                css`
                    justify-content: center;
                    img {
                        height: auto;
                    }
                `,
                null,
                null,
            ]);
        }}
    `,
};
